export const getRequiredDepthForVenetians = (
  productType: string,
  venetianValance: boolean,
  slatSize: string,
) => {
  if (productType === '' || slatSize === '') return [];

  const aluminiumVenetianBlindDepths = [
    {
      depth: '39mm',
    },
  ];

  const timberVenetianBlindDepths = [
    {
      venetianValance: true,
      slatSize: '50mm',
      depth: '92mm',
    },
    {
      venetianValance: false,
      slatSize: '50mm',
      depth: '68mm',
    },
    {
      venetianValance: true,
      slatSize: '63mm',
      depth: '99mm',
    },
    {
      venetianValance: false,
      slatSize: '63mm',
      depth: '68mm',
    },
  ];

  const pvcVenetianBlindDepths = [
    {
      venetianValance: true,
      slatSize: '50mm',
      depth: '92mm',
    },
    {
      venetianValance: false,
      slatSize: '50mm',
      depth: '68mm',
    },
    {
      venetianValance: true,
      slatSize: '63mm',
      depth: '99mm',
    },
    {
      venetianValance: false,
      slatSize: '63mm',
      depth: '68mm',
    },
  ];

  if (productType.includes('Aluminium')) {
    return aluminiumVenetianBlindDepths;
  } else if (productType.includes('PVC')) {
    return pvcVenetianBlindDepths
      .filter(options => options.slatSize === slatSize)
      .filter(options => options.venetianValance === venetianValance);
  } else {
    return timberVenetianBlindDepths
      .filter(options => options.slatSize === slatSize)
      .filter(options => options.venetianValance === venetianValance);
  }
};
